module.exports = __webpack_public_path__ + "static/media/csr_environment.44c1a4ca.jpg";